import React from 'react';
import {
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    ThreadsIcon,
    ThreadsShareButton,
    TwitterShareButton,
    XIcon
} from 'react-share';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button, DropdownSection } from "@heroui/react";
import CopyLinkButton from './CopyLinkButton';
import { string } from 'prop-types';


interface Share {
    shareUrl: string
    title: string
}

const Share: React.FC<Share> = ({
    shareUrl,
    title
}) => {

    return (
        <Dropdown backdrop="blur">
            <DropdownTrigger>
                <Button className='border-1 rounded-md hover:bg-black/30' variant="clear" >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                    </svg>

                </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Dynamic Actions" key={'dropdown-menu'} items={[]}>

                <DropdownSection showDivider >
                    <DropdownItem
                        key={'facebook'}
                        startContent={<FacebookIcon size={32} round />}
                    >
                        <div>
                            <FacebookShareButton title={title} className='flex w-full' url={shareUrl}>

                                <span>Facebook</span>
                            </FacebookShareButton>
                        </div>

                    </DropdownItem>

                    <DropdownItem
                        key={'threads'}
                        startContent={<ThreadsIcon size={32} round />}
                    >
                        <ThreadsShareButton
                            title={title}
                            url={shareUrl}
                            className='flex w-full'
                        >

                            <span>Threads</span>
                        </ThreadsShareButton>

                    </DropdownItem>

                    <DropdownItem
                        key={'x'}
                        startContent={<XIcon size={32} round />}
                    >
                        <TwitterShareButton
                            title={title}
                            url={shareUrl}
                            className='flex w-full'
                        >

                            <span>X</span>
                        </TwitterShareButton>

                    </DropdownItem>
                </DropdownSection>

                <DropdownSection >
                    <DropdownItem
                        key={'copylink'}
                        className='text-center'
                    >
                        <CopyLinkButton url={shareUrl} />

                    </DropdownItem>
                </DropdownSection>

            </DropdownMenu>
        </Dropdown>
    );
}

export default Share;